import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Get_Api } from "../Api_Url";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ContentLoader from "react-content-loader";

function CityDetails() {
  const navigate = useNavigate();
  const { city } = useParams();
  const location = useLocation();
  const id = location.state?.id;
  const [cities, setCities] = useState([]);
  const [country, setCountry] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCities = async () => {
    try {
      setLoading(true);
      // const response = await Get_Api(`api/admin/GetAllDestination?City=${id}`);
      const response = await Get_Api(`api/admin/GetAllDestinationByCityName/${city}`);
      setCities(response?.data);
      if (response?.data.length > 0) {
        setCountry(response.data[0].Country);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setLoading(false);
    }
  };

  const [IsUploading, setIsUploading] = useState(false);
  const [CityData, setCityData] = useState({});

  const GetACitydata = async () => {
    try {
      setIsUploading(true)
      const response = await Get_Api(`api/city/GetACity/${id}`)
      setCityData(response?.data)
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      console.log(error)
    }
  }


  useEffect(() => {
    GetACitydata();
    fetchCities();
  }, [city]);

  const cityDetails = (cityId) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/destinationdetail/${CityData?.name}/${cityId}`);
  };


  return (
    <>
      <Navbar />
      <div className="about-div">
        <h1>DESTINATION</h1>
        <p>
          <i>{country?.Name} - Destination</i>
        </p>
      </div>
      {
        country?.Heading && country?.Details && country?.extraImage &&

        <div className="vietnam-tours-container">
          <div className="vietnam-tours-text-content">
            <h1>{CityData?.Heading}</h1>
            <p>
              {CityData?.Details}
            </p>
            <div className="vietnam-tours-stats">
              <div>
                <h2>{CityData?.HeritageSites}</h2>
                <p>World Heritage Sites</p>
              </div>
              <div>
                <h2>{CityData?.EthnicMinorities}</h2>
                <p>Ethnic Minorities</p>
              </div>
            </div>
          </div>
          <div className="vietnam-tours-map-container">
            <img
              src={CityData?.extraImage}
              alt="Vietnam Map"
              className="vietnam-tours-map"
            />
          </div>
        </div>
      }
      <div style={{ textAlign: "center", padding: "20px" }}>
        <p>Whether you’re looking for places for a vacation. We are here to</p>
        <h1>Explore Packages</h1>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          padding: "20px"
        }}
      >
        {loading ? (
          <ContentLoader viewBox="0 0 820 450" height={"100%"} width={"100%"}>
            <rect x="10" y="10" rx="5" ry="5" width="260" height="140" />
            <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
            <rect x="550" y="10" rx="5" ry="5" width="260" height="140" />
            <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
            <rect x="280" y="300" rx="5" ry="5" width="260" height="140" />
            <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
          </ContentLoader>
        ) : (
          cities.map((city) => (
            // <div
            //   key={city._id}
            //   style={{
            //     width: "300px",
            //     padding: "15px",
            //     borderRadius: "10px",
            //     backgroundColor: "#f9f9f9",
            //     boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            //     textAlign: "center"
            //   }}
            // >
            //   <Helmet>
            //     <title>{CityData?.MetaTitle || "Destination Details"}</title>
            //     <meta
            //       name="description"
            //       content={
            //         CityData?.MetaDescription || "Explore destination details"
            //       }
            //     />
            //     {CityData?.MetaTags?.map((tag, index) => (
            //       <meta key={index} name="keywords" content={tag} />
            //     ))}
            //   </Helmet>
            //   <div
            //     style={{
            //       backgroundImage: `url(${city?.Gallary[0]})`,
            //       height: "200px",
            //       backgroundSize: "cover",
            //       backgroundPosition: "center",
            //       borderRadius: "10px"
            //     }}
            //   ></div>
            //   <h3 style={{ margin: "10px 0" }}>{city.name}</h3>
            //   <p>{city.description}</p>
            //   <button
            //     onClick={() => cityDetails(city?.DestinationName)}
            //     style={{
            //       padding: "10px 15px",
            //       backgroundColor: "#007bff",
            //       color: "white",
            //       border: "none",
            //       borderRadius: "5px",
            //       cursor: "pointer"
            //     }}
            //   >
            //     View Details
            //   </button>
            // </div>
            <div className="destination-card" style={{ backgroundImage: `url(${city?.BannerImage})` }}>
              <Helmet>
                <title>{CityData?.MetaTitle || "Destination Details"}</title>
                <meta
                  name="description"
                  content={CityData?.MetaDescription || "Explore destination details"}
                />
                {CityData?.MetaTags?.map((tag, index) => (
                  <meta key={index} name="keywords" content={tag} />
                ))}
              </Helmet>

              <div className="city-info">
                <h3>{city?.DestinationName}</h3>
                <p>{city?.Heading}</p>
                <button onClick={() => cityDetails(city?.DestinationName)}>View Details</button>
              </div>
            </div>
          ))
        )}
      </div>
      <Footer />
    </>
  );
}

export default CityDetails;
